<template>
  <div class="hello">
    <div v-if="data.type_zn=='公众号'">
      <iframe :src="data.content" width="" height=""></iframe>
    </div>
    <div v-else>
      <div class="xinxi_title">
        {{data.title}}
      </div>

      <div class="time">
        {{data.create_time}}
      </div>
      <div style="text-align: left;" v-html="data.content"></div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        data: []
      }
    },
    created() {
      this.$http.newsDetail({
        id: this.$route.query.id
      }).then(res => {
        this.data = res.data
      })
    }
  }
</script>

<style scoped>
  .hello {
    width: 1280px;
    margin: 40px auto;
  }

  img {
    width: 1000px;
    height: 300px;
  }

  .time {
    color: #999;
    margin: 30px 0;
  }

  .xinxi_title {
    font-size: 20px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/view/info/xinxiDetail.vue